import { useState } from 'react';
import {
  Typography,
  CircularProgress,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';

import { capitalize } from '../../../utils/strings';

const DialogBase = ({
  onExit,
  disabled,
  showCancel = true,
  confirmText = 'Submit',

  submit,
  id,
  children,
}) => {
  const [error, setError] = useState();
  const [submitting, setSubmitting] = useState('');
  return (
    <>
      <DialogTitle>Confirm {capitalize(id)}</DialogTitle>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          setSubmitting('Processing Request');
          submit(event.target)
            .then((result) => {
              setSubmitting('');
              return onExit ? onExit(result) : result;
            })
            .catch((e) => {
              setSubmitting('');
              setError(e.message);
            });
        }}
        onReset={onExit}
        id={id}
      >
        <DialogContent sx={{ paddingTop: '0px' }}>
          {children}
          {error ? (
            <Typography sx={{ padding: '10px' }} color="error">
              {error.replaceAll('<br />', '\n')}
            </Typography>
          ) : null}
        </DialogContent>
        <DialogActions>
          {showCancel ? (
            <Button type="reset" form={id}>
              Cancel
            </Button>
          ) : null}
          <Button
            variant="contained"
            color="success"
            type="submit"
            form={id}
            disabled={disabled || submitting}
          >
            {submitting ? (
              <CircularProgress color="success" size="24px" aria-label="Processing…" />
            ) : (
              confirmText
            )}
          </Button>
        </DialogActions>
      </form>
    </>
  );
};

export default DialogBase;
